const COMMON_FETCH_LANGUAGES = {
  START: 'START_COMMON_FETCH_LANGUAGES',
  COMPLETE: 'COMPLETE_COMMON_FETCH_LANGUAGES',
  FAIL: 'FAIL_COMMON_FETCH_LANGUAGES',
  CLEANUP: 'CLEANUP_COMMON_FETCH_LANGUAGES',
}

export default COMMON_FETCH_LANGUAGES
